module.exports = __webpack_public_path__ + "img/harry_potter_01_and_the_sorcerers_stone_scan.e01831d4.jpg";